import { CircularProgress, CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import useValidateToken from 'hooks/useValidateToken';
import NavigationScroll from './layout/NavigationScroll';
import Routes from './routes';
import themes from './themes';
import { useLocation, useNavigate } from 'react-router-dom';
import { REDEEM_PATH } from 'constant/path';
import { useAppSelector } from 'reducers/models';
import { useEffect } from 'react';
import { setNavigator } from 'utils/navigation';

const App = () => {
  const { isTokenChecked } = useValidateToken();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSessionRedeem = useAppSelector((state) => state.auth.isSessionRedeem);

  useEffect(() => {
    console.log('RedeemSession', isSessionRedeem);
  }, [isSessionRedeem]);

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  if (!isTokenChecked && pathname !== REDEEM_PATH)
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress size={30} />
      </div>
    );
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes()}>
        <CssBaseline />
        <NavigationScroll>
          <Routes />
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
